import Vue from 'vue'
import store from '../store'

const requestInterceptor = config => {
  if (store.getters['auth/isLoggedIn']) {
    config.headers[store.state.auth.config.jwtHeader] = `${store.state.auth.config.jwtPrefix} ${store.state.auth.token}`
  }

  return config
}

const responseInterceptor = response => {
  // store.dispatch('setError', {})
  return response
}

const errorInterceptor = error => {
  if (!error.request) {
    error.message = 'Request cancelled'
    return Promise.reject(error.message)
  }
  if (error.request.responseURL.indexOf('authorization') === -1) {
    switch (error.response.status) {
      case 401:
        store.dispatch('auth/logout')
        Vue.$router.push({ name: 'login' })
        // const originalRequest = error.config
        // if (store.state.auth.isLoggedIn && !originalRequest._retry) {
        //   originalRequest._retry = true
        //   store.dispatch('auth/refreshToken', {originalRequest: originalRequest})
        // } else {
        //   store.dispatch('auth/logout')
        // }
        break
      case 404:
        // eslint-disable-next-line no-console
        console.log('page not found')
        break
      default:
        break
    }
    return Promise.reject(error.response)
  }
}

export { requestInterceptor, responseInterceptor, errorInterceptor }
